module.exports = __webpack_public_path__ + "static/img/7.72af762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/7.jpg
// module id = Aqzp
// module chunks = 21